import React from 'react';
import { Link } from 'gatsby';

import styles from './Pagination.module.scss';

const Pagination = ({
  hasPreviousPage,
  hasNextPage,
  currentPage,
  rootPath,
  light
}) => {
  console.log(light);
  return (
    <div className={`${styles.pagination} ${light ? styles.light : ''}`}>
      <div className={styles.wrapper}>
        <div>
          {hasNextPage && (
            <Link to={`${rootPath}/${currentPage + 1}`}>
              &#8592; Previous news
            </Link>
          )}
        </div>
        <div>
          {hasPreviousPage && (
            <Link
              to={
                currentPage - 1 === 1
                  ? rootPath
                  : `${rootPath}/${currentPage - 1}`
              }
            >
              Next news &#8594;
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};

export default Pagination;
